import { useUiStore } from '@/stores'
import { TaskList, TaskDetail } from '@/components/Tasks'
import { useTask } from '@/hooks/useTasks'
import type { Task } from '@/api'

export function Tasks() {
  const { selectedTaskId, setSelectedTaskId } = useUiStore()
  const { data: selectedTask } = useTask(selectedTaskId ?? '')

  return (
    <div className="space-y-6">
      {/* Page header */}
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Tasks</h1>
        <p className="text-muted-foreground">
          Manage and track your work items.
        </p>
      </div>

      {/* Main content */}
      <div className="flex gap-6">
        {/* Task list (responsive width) */}
        <div className={selectedTask ? 'flex-1 lg:max-w-[calc(100%-400px)]' : 'w-full'}>
          <TaskList
            onTaskSelect={(t: Task) => setSelectedTaskId(t.id)}
            selectedTaskId={selectedTaskId ?? undefined}
          />
        </div>

        {/* Task detail panel (desktop only) */}
        {selectedTask && (
          <div className="hidden lg:block w-[380px] shrink-0">
            <div className="sticky top-6">
              <TaskDetail
                task={selectedTask}
                onClose={() => setSelectedTaskId(null)}
                onStatusChange={(t: Task) => setSelectedTaskId(t.id)}
              />
            </div>
          </div>
        )}
      </div>

      {/* Task detail modal (mobile) - slide up from bottom */}
      {selectedTask && (
        <div className="lg:hidden fixed inset-0 z-50">
          <div
            className="absolute inset-0 bg-background/80 backdrop-blur-sm"
            onClick={() => setSelectedTaskId(null)}
          />
          <div className="absolute bottom-0 left-0 right-0 max-h-[80vh] bg-background rounded-t-xl border-t border-border/30 shadow-2xl overflow-hidden">
            <TaskDetail
              task={selectedTask}
              onClose={() => setSelectedTaskId(null)}
              onStatusChange={(t: Task) => setSelectedTaskId(t.id)}
            />
          </div>
        </div>
      )}
    </div>
  )
}
